import { useContext } from "react";

import { ToastContext } from "./provider";

export const useToast = () => {
  return useContext(ToastContext);
};
